<div class="content-section" *ngIf="content$ | async as data; else loadingTpl">
  <ng-container *ngIf="data['Conoce-mas-sobre-la-reforma']?.beneficios?.['compensacion-mujeres'] as cm">
    <div class="text-content">
      <p class="description" [innerHTML]="cm.description1"></p>

      <p class="description" [innerHTML]="cm.description2"></p>

      <p class="subtitle">{{ cm.subtitle }}</p>

      <div class="chart-container">
        <icon-compensacion-mujeres-chart *ngIf="!isVersionMobile" aria-hidden="true"></icon-compensacion-mujeres-chart>
        <icon-compensacion-mujeres-chart-orientacion-abajo *ngIf="isVersionMobile" aria-hidden="true"></icon-compensacion-mujeres-chart-orientacion-abajo>
      </div>

      <div class="note-box">
        <p>{{ cm.noteExplanation }}</p>
        <p [innerHTML]="cm.noteExample"></p>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTpl>
  <app-text-skeleton [lines]="5"></app-text-skeleton>
</ng-template>